import styled, { device } from '@styled'

export const TeamWrapper = styled.section`
  padding-block-start: 20px;
  scroll-margin-top: 100px;
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 50px;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`
